import { render, staticRenderFns } from "./EN_MobileAppMenu.vue?vue&type=template&id=a2b46066&"
import script from "./EN_MobileAppMenu.vue?vue&type=script&lang=js&"
export * from "./EN_MobileAppMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports